import type { EnvironmentModel } from "../types/EnvironmentModelTypes";

export const environment: EnvironmentModel = {
  uhfApiUrl:
    "https://uhf.microsoft.com/en-us/shell/xml/MSMCapTools?HeaderId=MSMCapToolsHeader&FooterId=MSMCapToolsFooter",
  uhfLocalePickersUrl: "assets/culture-dictionary.json",
} as EnvironmentModel;
